import Repository from './Repository'

const resource = 'judges-results-exercises'

export default {
  getJudgeResultExercises (executionId, params) {
    return Repository.get(`executions/${executionId}/${resource}`, {
      params: params
    })
  }
}
